import { useQuery, useReactiveVar } from "@apollo/client";
import {
    Button,
    HStack,
    Link as ChakraLink,
    Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CardList } from "../../components/containers/cardList/CardList"
import { ListCard } from "../../components/listCard/ListCard";
import { ComponentLoading } from "../../components/loading/ComponentLoading";
import { PaginationBar } from "../../components/paginationBar/PaginationBar";
import { OptimisationPackageTypeEdge } from "../../graphql/generated";
import { GET_GAM_CAMPAIGN_LIST_PAGINATED } from "../../graphql/operations/campaignOperations/operations";
import { useAuth } from "../../lib/auth";
import {
    gamCampaignSearchFilterVar, gamCampaignStatusFilterVar,
} from "../../lib/cache";
import { getPartnerName } from "../../utils/displayGetters";

export const GamCampaignHomeBody = () => {
    const [pageNumber, setPageNumber] = useState(0);
    const pageSize = 10;
    const statusFilter = useReactiveVar(gamCampaignStatusFilterVar);
    const searchFilter = useReactiveVar(gamCampaignSearchFilterVar);

    const navigate = useNavigate();
    const { signOut } = useAuth();
    const signOutAndGoToLogin = () => {
      signOut();
      navigate("/login");
    };

    useEffect(() => {
      setPageNumber(0);
    }, [searchFilter]);

    const { data, loading, error } = useQuery(GET_GAM_CAMPAIGN_LIST_PAGINATED, {
      variables: {
        isActive: statusFilter === "ALL" ? undefined : statusFilter,
        search: searchFilter.trim(),
        first: pageSize,
        offset: pageNumber * pageSize,
      },
      fetchPolicy: "cache-and-network",
    });

    if (loading) {
      return <ComponentLoading text={"Getting segments..."} />;
    }

    if (error) {
      return (
        <>
          <div>
            There seems to be a problem. Please sign out and and sign back in.
          </div>
          <ChakraLink onClick={signOutAndGoToLogin}>
            Click here to sign out
          </ChakraLink>
        </>
      );
    }

    const packageList = data.optimisationPackageListPaginated.edges;
    const totalPageCount = Math.ceil(
      data.optimisationPackageListPaginated.totalCount / pageSize
    );

    return (
      <>
        {packageList.length === 0 && !searchFilter ? (
          <HStack>
            <Text fontWeight={"medium"} fontSize={"18px"} color={"link"}>
              {"You haven't created any Campaigns yet. Create a"}
            </Text>
            <Link to={"new"}>
              <Button variant={"primary"} size={"sm"}>
                New Campaign
              </Button>
            </Link>
          </HStack>
        ) : (
          <>
            <CardList mt={5}>
              {packageList.map((edge: OptimisationPackageTypeEdge) => (
                <ListCard
                    key={edge.node.uniqueId}
                    id={edge.node.uniqueId}
                    name={edge.node.name}
                    startDate={edge.node.startDate}
                    endDate={edge.node.endDate}
                    status={edge.node.active}
                    additionalTagsStaff={[
                        getPartnerName(edge.node.partner),
                    ]}
                />
              ))}
            </CardList>
            {(searchFilter) &&
              packageList.length === 0 && (
                <Text
                  fontSize={"18px"}
                  color={"muted"}
                  textAlign={"center"}
                  mt={4}
                >
                  No campaigns match your current parameters...
                </Text>
              )}
          </>
        )}
        {packageList.length !== 0 && (

            <PaginationBar
              currentPageIndex={pageNumber}
              totalPageCount={totalPageCount}
              setPage={setPageNumber}
              mt={4}
              gridGap={4}
            />
        )}
      </>
    );
}
